import { Box } from '@chakra-ui/react'
import { type QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

import { TabletNotFoundState } from '@/widgets/tablet/not-found-state'

export interface MyRouterContext {
    queryClient: QueryClient
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
    component: Root,
    notFoundComponent: () => <TabletNotFoundState variant='invalid-link' />,
})

function Root() {
    return (
        <Box bg='custard.100' minH='100dvh' w='full'>
            <Outlet />
        </Box>
    )
}
